import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkAssignCategoriesToProgramRequest = {};
var _bulkAssignCategoriesToProgramResponse = {
    results: '_bulkAssignCategoryResult',
};
var _bulkAssignCategoryResult = { item: '_category' };
var _bulkCategoryResult = { item: '_category' };
var _bulkCreateCategoryRequest = { categories: '_category' };
var _bulkCreateCategoryResponse = { results: '_bulkCategoryResult' };
var _category = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_category' };
var _listCategoriesRequest = {};
var _listCategoriesResponse = { categories: '_category' };
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _updateCategoryRequest = {
    mask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _updateCategoryResponse = { category: '_category' };
function resolveWixAchievementsCategoriesV3CategoriesServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
            {
                srcPath: '/program-categories-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/program-categories-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new Category */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'POST',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.CreateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Creates new categories in a bulk */
export function bulkCreateCategory(payload) {
    var _a = serializer(_bulkCreateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateCategoryResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
    }).fromJSON;
    function __bulkCreateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'POST',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.BulkCreateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/bulk/categories/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateCategory.fromReq = fromReq;
    __bulkCreateCategory.__isAmbassador = true;
    return __bulkCreateCategory;
}
/** Get a Category by id */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, { _category: _category }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'GET',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.GetCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/** Get list of categories by list of ids */
export function listCategories(payload) {
    var _a = serializer(_listCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __listCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'GET',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.ListCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCategories.fromReq = fromReq;
    __listCategories.__isAmbassador = true;
    return __listCategories;
}
/**
 * Update a Category, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'PATCH',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.UpdateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Delete a Category */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'DELETE',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.DeleteCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/** Query Categories using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'POST',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.QueryCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Assign or unassign categories to a program */
export function bulkAssignCategoriesToProgram(payload) {
    var _a = serializer(_bulkAssignCategoriesToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAssignCategoriesToProgramResponse, { _bulkAssignCategoryResult: _bulkAssignCategoryResult, _category: _category }).fromJSON;
    function __bulkAssignCategoriesToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.categories.v3.category',
            method: 'POST',
            methodFqn: 'wix.achievements.categories.v3.CategoriesService.BulkAssignCategoriesToProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixAchievementsCategoriesV3CategoriesServiceUrl({
                protoPath: '/v3/categories/bulk-assign-to-program',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAssignCategoriesToProgram.fromReq = fromReq;
    __bulkAssignCategoriesToProgram.__isAmbassador = true;
    return __bulkAssignCategoriesToProgram;
}
//# sourceMappingURL=http.impl.js.map